import { gql } from '@apollo/client';
import type { PricingResultType, QueryPricingResult } from '../../../settlement/graphql/mutations/pricingQueryMutations';

export interface QueryPricingFailureRevisionByConditionResponse {
  queryPricingFailureRevisionByCondition: QueryPricingResult & {
    data: PricingResultType[];
  };
}

export interface QueryPricingFailureRevisionByConditionVariables {
  input: {
    clientIds?: number[] | null;
    businessAtStart?: string | null;
    businessAtEnd?: string | null;
    businessTimeZoneId?: string | null;
    pricingErrorCode?: string | null;
    pricingNodeCode?: string | null;
    businessScenarioCode?: number | null;
    isSuccess?: boolean | null;
    page?: number;
    pageSize?: number;
    cursor?: string | null;
    batchPages: number;
  };
}

export const QUERY_PRICING_FAILURE_REVISION_BY_CONDITION = gql`
  query QueryPricingFailureRevisionByCondition($input: QueryPricingByConditionInput!) {
    queryPricingFailureRevisionByCondition(input: $input) {
      success
      message
      data {
        id
        businessCode
        businessScenarioCode
        businessFeeCode
        pricingAt
        businessAt
        businessId
        amount
        clientId
        otherBusinessId
        isSuccess
        pricingNodeCode
        pricingErrorCode
      }
      totalCount
      nextCursor
    }
  }
`;

